import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../common/models';
import { ProfileState } from './profile.state';
import { ChangePasswordModel, ProfileModel } from './models';
import {
  ProfileChangePassword,
  ProfileDelete,
  ProfileInitialState,
  ProfileLoad,
  ProfileUpdate,
  ProfileUpdatePassword,
} from './profile.actions';
import { ProfileStateModel } from './profile.state';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class ProfileFacade implements LoadDataFacade, SetInitialStateFacade {
  profileData$: Observable<ProfileStateModel> = this.store.select(ProfileState.getState);
  loaded$: Observable<boolean> = this.store.select(ProfileState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new ProfileLoad());
  }

  updateProfile(data: ProfileModel): void {
    this.store.dispatch(new ProfileUpdate(data));
  }

  changeUserPassword(body: ChangePasswordModel, dialogRef: MatDialogRef<unknown>): void {
    this.store.dispatch(new ProfileChangePassword({ body, dialogRef }));
  }

  updateUserPassword(body: ChangePasswordModel): void {
    this.store.dispatch(new ProfileUpdatePassword({ body }));
  }

  deleteProfile(dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new ProfileDelete({ dialog }));
  }

  setInitialState(): void {
    this.store.dispatch(new ProfileInitialState());
  }
}
